import React, { createContext, useContext, useState } from "react";

// Per-device Classroom Mode: locks the shared classroom device down to a small set
// of kid-safe surfaces (Sign-Out, Attendance, Library/Lending) so students clicking
// around can't start an emergency, open Settings, see rosters, or sign the teacher
// out. It's a DEVICE flag (localStorage), not a role — the device is still signed
// into the teacher's account. A 4-digit PIN (on the user doc) is required to exit.
//
// Security boundary: this deters curious kids; it is NOT hardened against someone
// who can open devtools and clear localStorage (fine for managed/kiosk Chromebooks).
const STORAGE_KEY = "classboon-classroom-mode";

const ClassroomModeContext = createContext({
  classroomMode: false,
  enterClassroomMode: () => {},
  exitClassroomMode: () => {},
});

function readInitial() {
  try {
    return localStorage.getItem(STORAGE_KEY) === "1";
  } catch {
    return false; // localStorage unavailable (private mode, etc.)
  }
}

export function ClassroomModeProvider({ children }) {
  const [classroomMode, setClassroomMode] = useState(readInitial);

  const enterClassroomMode = () => {
    try { localStorage.setItem(STORAGE_KEY, "1"); } catch { /* ignore */ }
    setClassroomMode(true);
  };
  const exitClassroomMode = () => {
    try { localStorage.removeItem(STORAGE_KEY); } catch { /* ignore */ }
    setClassroomMode(false);
  };

  return (
    <ClassroomModeContext.Provider value={{ classroomMode, enterClassroomMode, exitClassroomMode }}>
      {children}
    </ClassroomModeContext.Provider>
  );
}

export function useClassroomMode() {
  return useContext(ClassroomModeContext);
}
